import { render, staticRenderFns } from "./MediaTypeSegmented.vue?vue&type=template&id=2f682976&scoped=true&"
import script from "./MediaTypeSegmented.vue?vue&type=script&lang=js&"
export * from "./MediaTypeSegmented.vue?vue&type=script&lang=js&"
import style0 from "./MediaTypeSegmented.vue?vue&type=style&index=0&id=2f682976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f682976",
  null
  
)

export default component.exports